import styled from 'styled-components'

export const Container = styled.div`
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Message = styled.div`
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #777;
  margin: 30px 0;
  font-size: 17px;
`

export const MainAnimation = styled.div`
  display: flex;
  align-items: center;
`